import React from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import AboutSection from "../components/AboutSection";
import AreasSection from "../components/AreasSection";
import ProjectsSection from "../components/ProjectsSection";
import HubAcreSection from "../components/HubAcreSection";
import PartnersSection from "../components/PartnersSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import WhatsAppFloat from "../components/WhatsAppFloat";
import OpportunitiesPopup from "../components/OpportunitiesPopup";

const HomePage = () => {
  return (
    <>
      <OpportunitiesPopup />

      <div className="homepage">
        <Header />
        <HeroSection />
        <AboutSection />
        <AreasSection />
        <ProjectsSection />
        <HubAcreSection />
        <PartnersSection />
        <ContactSection />
        <Footer />
        <WhatsAppFloat />
      </div>
    </>
  );
};

export default HomePage;
